/**
 * Signed note PDF export bot client.
 */
import { ContentType } from '@medplum/core';
import type { MedplumClient } from '@medplum/core';
import type { DocumentReference, Identifier } from '@medplum/fhirtypes';

export const SIGNED_NOTE_EXPORT_BOT_IDENTIFIER = {
  system: 'https://unify.health/bots',
  value: 'signed-note-export',
} as const;

function getBotTarget(): string | Identifier {
  const id = import.meta.env.VITE_MEDPLUM_SIGNED_NOTE_EXPORT_BOT_ID?.trim();
  if (id) return id;
  return {
    system:
      import.meta.env.VITE_MEDPLUM_SIGNED_NOTE_EXPORT_BOT_IDENTIFIER_SYSTEM?.trim() ??
      SIGNED_NOTE_EXPORT_BOT_IDENTIFIER.system,
    value:
      import.meta.env.VITE_MEDPLUM_SIGNED_NOTE_EXPORT_BOT_IDENTIFIER_VALUE?.trim() ??
      SIGNED_NOTE_EXPORT_BOT_IDENTIFIER.value,
  };
}

export async function requestSignedNoteExport(
  medplum: MedplumClient,
  questionnaireResponseId: string,
): Promise<DocumentReference> {
  const result = await medplum.executeBot(
    getBotTarget(),
    { questionnaireResponseId },
    ContentType.JSON,
  );
  if (!result || typeof result !== 'object' || (result as DocumentReference).resourceType !== 'DocumentReference') {
    throw new Error('Signed note export bot did not return a DocumentReference');
  }
  return result as DocumentReference;
}
